var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._l((_vm.terms),function(term,index){return _c('SchoolTerm',_vm._b({key:term.Id,on:{"remove":function($event){return _vm.onTermRemoved($event)},"change":function($event){return _vm.$emit('change')}}},'SchoolTerm',{ term, index, start: _vm.start, end: _vm.end },false))}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }